/**
 * Created by calhosh on 4/14/2017.
 */

import * as globalEnglish from './en-us';
import * as spanish from './es-mx';
import * as japanese from './ja-jp';
import * as arabic from './ar-ms';
import * as frenchCanadian from './fr-ca';
import * as hebrew from './he';
import * as korean from './ko';
import * as portugueseBrazilian from './pt-br';
import * as russian from './ru';
import * as chineseSimplified from './zh-sp';
import * as chineseTraditional from './zh-tr';
import _ from 'lodash';

const languages = {
	'en-us': globalEnglish,
	'es-mx': spanish,
	'ja-jp': japanese,
	'ar-ms': arabic,
	'fr-ca': frenchCanadian,
	he: hebrew,
	ko: korean,
	'pt-br': portugueseBrazilian,
	ru: russian,
	'zh-sp': chineseSimplified,
	'zh-tr': chineseTraditional
};

export const resources = function (locale) {
	return _.merge({}, languages['en-us'], languages[locale]);
}
